import { createUserManager } from 'redux-oidc';
import { WebStorageStateStore } from 'oidc-client';

const userManagerConfig = {
  authority: process.env.AUTHORITY_URL,
  client_id: 'openid',
  redirect_uri: window.location.origin + '/callback',
  post_logout_redirect_uri: window.location.origin + '/login',
  response_type: 'id_token token',
  scope: 'openid profile identity.api identity.profile',
  silent_redirect_uri: window.location.origin + '/silent_renew.html',
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({store: localStorage})
};


const userManager = createUserManager(userManagerConfig);

export default userManager;


// WEBPACK FOOTER //
// ./src/utils/userManager.js